import { useLayoutEffect } from 'react';
import { useSelector } from 'react-redux';
import bowser from 'yola-bowser';
import getIntegrationType from '../../selectors/get-integration-type';
import integrationTypes from '../../constants/integration-types';

const isTouchDevice = bowser.mobile || bowser.tablet;

const useHideZendeskOnTouchDevice = () => {
  const integrationType = useSelector(getIntegrationType);

  useLayoutEffect(() => {
    if (integrationType !== integrationTypes.ZENDESK || !isTouchDevice || !window.zE) {
      return () => {};
    }

    document.getElementById('launcher').style.transition = 'none';
    window.zE('webWidget', 'hide');

    return () => {
      window.zE('webWidget', 'show');
    };
  }, [integrationType]);
};

export default useHideZendeskOnTouchDevice;
